export default (value) => {
    const fileSize = parseFloat(value);
    
    if (fileSize / (1024*1024) >= 1) {
        return (fileSize / (1024*1024)).toFixed(2) + " MB";    
    }
    return (fileSize / 1024).toFixed(2) + " kB";    
}